var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.PricesListCard,
    { attrs: { "show-all-href": _vm.showAllHref } },
    _vm._l(_vm.items, function (item, index) {
      return _c(
        "a",
        {
          key: item.translit,
          staticClass:
            "lpu-prices-ranges d-flex text-decoration-none rounded-20",
          class: [
            _setup.isMobile
              ? "flex-column ga-3 pa-4"
              : "align-center ga-8 px-4 py-3",
            { "bg-gray-40": index % 2 === 1 },
          ],
          attrs: { href: `${_vm.pricesPath}#${item.translit}` },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "lpu-prices-ranges__name text-body-1 text--text min-w-0",
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_setup.tDynamic(item, "name") || item.name) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text-subtitle-1 text--text flex-shrink-0",
              class: { "text-right": !_setup.isMobile },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_setup.formatRange(item.min, item.max)) +
                  "\n    "
              ),
            ]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }